import CreditCardAnd123 from './CreditCardAnd123';

export default CreditCardAnd123;
